import api from '@/plugins/axios';
import { mountUrl } from './helper';

const BASE_PATH = 'budget_payment_methods';

export default {
  async create(body) {
    const url = mountUrl(`/${BASE_PATH}`);
    return api.post(url, body);
  },
  async inactivate(budgetId, paymentMethodId) {
    const url = mountUrl(`/${BASE_PATH}/${budgetId}/${paymentMethodId}`);
    return api.delete(url);
  }
};
